// extracted by mini-css-extract-plugin
export var defaultWrapper = "_no-3";
export var downloadButton = "_no-4";
export var fileContainer = "_no-9 _no-7";
export var fileContainerBase = "_no-7";
export var fileContainerFixedHeight = "_no-8 _no-7";
export var fileInfo = "_no-5";
export var fileInfoWidthRestricted = "_no-6";
export var fileType = "_no-1";
export var fileTypeName = "_no-2";
export var image = "_no-0";
export var link = "_no-b";
export var overflowEllipsis = "_no-a";